/**
 * Точка входа webpack: landing.robots
 */
import './robots.css';
import '../../common.js';
import '../../modules/partners/partners.js';
import { initFaq } from '../../modules/faq/faq.js';
import '../../modules/tariffs/tariffs.js';
import { initReviews } from '../../modules/reviews/reviews.js';

const SEARCH_LENGTH_LOAD_DATA = 4;
const SEARCH_DELAY_LOAD_DATA = 500;

function fetchHeroSuggestions(apiUrl, query, baseName) {
    const url = apiUrl + '/suggestion/domain'
        + '?query=' + encodeURIComponent(query)
        + '&base=' + encodeURIComponent(baseName);

    // Без кастомных заголовков — простой CORS GET, без OPTIONS preflight
    return fetch(url, {
        credentials: 'include',
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Suggestion request failed');
            }

            return response.json();
        })
        .then(function (payload) {
            if (Array.isArray(payload)) {
                return payload;
            }

            if (payload && Array.isArray(payload.data)) {
                return payload.data;
            }

            return [];
        })
        .catch(function () {
            return [];
        });
}

function initHeroSearch(form) {
    if (form.getAttribute('data-hero-search-initialized') === '1') {
        return;
    }

    const input = form.querySelector('[data-hero-search-input]');
    const suggestionsPanel = form.querySelector('[data-hero-search-suggestions]');
    const suggestionsList = form.querySelector('[data-hero-search-suggestions-list]');

    if (!input || !suggestionsPanel || !suggestionsList) {
        return;
    }

    form.setAttribute('data-hero-search-initialized', '1');

    const apiUrl = (form.getAttribute('data-api-url') || '').replace(/\/$/, '');
    const baseName = form.getAttribute('data-current-db') || '';

    let suggestions = [];
    let allowSuggestion = true;
    let suggestionTimer = null;
    let activeSuggestionIndex = -1;

    function hideSuggestions() {
        suggestionsPanel.hidden = true;
        suggestionsList.innerHTML = '';
        suggestions = [];
        activeSuggestionIndex = -1;
    }

    function renderSuggestions() {
        suggestionsList.innerHTML = '';

        if (!suggestions.length) {
            hideSuggestions();
            return;
        }

        suggestions.forEach(function (suggestion, index) {
            const item = document.createElement('li');
            item.className = 'p-autocomplete-item font-light';
            item.setAttribute('role', 'option');
            item.textContent = suggestion;

            if (index === activeSuggestionIndex) {
                item.classList.add('p-highlight');
            }

            item.addEventListener('mousedown', function (event) {
                event.preventDefault();
            });

            item.addEventListener('click', function () {
                allowSuggestion = false;
                input.value = suggestion;
                hideSuggestions();
                form.requestSubmit();
            });

            suggestionsList.appendChild(item);
        });

        suggestionsPanel.hidden = false;
    }

    function scheduleSuggestions() {
        clearTimeout(suggestionTimer);

        if (!allowSuggestion || !apiUrl || !baseName) {
            return;
        }

        const query = input.value.trim();

        if (!query || query.length < SEARCH_LENGTH_LOAD_DATA) {
            hideSuggestions();
            return;
        }

        suggestionTimer = setTimeout(function () {
            fetchHeroSuggestions(apiUrl, query, baseName)
                .then(function (response) {
                    suggestions = response;
                    activeSuggestionIndex = -1;
                    renderSuggestions();
                });
        }, SEARCH_DELAY_LOAD_DATA);
    }

    input.addEventListener('input', function () {
        allowSuggestion = true;
        scheduleSuggestions();
    });

    input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            hideSuggestions();
            form.requestSubmit();
            return;
        }

        if (!suggestions.length || suggestionsPanel.hidden) {
            return;
        }

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            activeSuggestionIndex = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
            renderSuggestions();
        }

        if (event.key === 'ArrowUp') {
            event.preventDefault();
            activeSuggestionIndex = Math.max(activeSuggestionIndex - 1, 0);
            renderSuggestions();
        }

        if (event.key === 'Escape') {
            hideSuggestions();
        }
    });

    form.addEventListener('submit', function (event) {
        if (!input.value.trim()) {
            event.preventDefault();
        }
    });

    document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) {
            hideSuggestions();
        }
    });
}

function initHeroSearches() {
    document.querySelectorAll('[data-hero-search]').forEach(initHeroSearch);
}

function init() {
    initHeroSearches();
    initFaq();
    initReviews();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
